module.exports = __webpack_public_path__ + "img/TS6202-312.0663a9ad.jpg";